import { Button } from '@/components/Elements';
import user from '@/assets/anderson.png';
import loc from '@/assets/location.png';

const RequestSend = () => {
  return (
    <div className="agency-card-row lawyer-rq">
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <h5 className="text-black mb-1">Henry</h5>
              <p className="f-13 d-flex gap-2 align-items-center">
                <img src={loc} className="loc-icon" /> New York, USA
              </p>
              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
            <Button className="rounded-full  mt-3 f-13" size="sm">
              Send Request
            </Button>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <h5 className="text-black mb-1">Henry</h5>
              <p className="f-13 d-flex gap-2 align-items-center">
                <img src={loc} className="loc-icon" /> New York, USA
              </p>
              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
            <Button className="rounded-full  mt-3 f-13" size="sm">
              Send Request
            </Button>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <h5 className="text-black mb-1">Henry</h5>
              <p className="f-13 d-flex gap-2 align-items-center">
                <img src={loc} className="loc-icon" /> New York, USA
              </p>
              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
            <Button className="rounded-full  mt-3 f-13" size="sm">
              Send Request
            </Button>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mb-4">
          <div className="lawyer-boxes d-flex flex-wrap">
            <div className="lawyer-rq-icon">
              <img src={user} className="law-user-icon" />
            </div>
            <div className="lawyer-rq-cnt">
              <h5 className="text-black mb-1">Henry</h5>
              <p className="f-13 d-flex gap-2 align-items-center">
                <img src={loc} className="loc-icon" /> New York, USA
              </p>
              <div className="row mt-3">
                <div className="col-12 col-md-5">
                  <h5 className="mb-0 text-black f-14">5484584526</h5>
                  <p className="f-13">Phone Number</p>
                </div>
                <div className="col-12 col-md-7">
                  <h5 className="mb-0 text-black f-14">Example123@gmail.com</h5>
                  <p className="f-13">Email</p>
                </div>
              </div>
            </div>
            <Button className="rounded-full  mt-3 f-13" size="sm">
              Send Request
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RequestSend;
